import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PageSet } from "src/pageDefinitions/types";

const linearBuyflowName = createSlice({
  name: "linearBuyflowName",
  initialState: null as string,
  reducers: {
    setActivePageSet(state, action: PayloadAction<PageSet>) {
      return action.payload.id;
    },
  },
});

export const { setActivePageSet } = linearBuyflowName.actions;

export default linearBuyflowName.reducer;
